import React, { useState } from "react";
import { Link } from "react-router-dom";

const ConsultancyFooter = () => {
  const [email, setEmail] = useState("");
  const [subscribed, setSubscribed] = useState(false);

  const handleSubscribe = (e) => {
    e.preventDefault();
    if (email) {
      setSubscribed(true);
      setTimeout(() => setSubscribed(false), 4000);
      setEmail("");
    }
  };

  return (
    <footer className="consultancy-footer pt-5 pb-4 mt-5" style={{ backgroundColor: "rgba(6, 8, 14, 0.95)", borderTop: "1px solid rgba(212, 175, 55, 0.12)", color: "#b0b0b0" }}>
      <div className="container">
        {/* Top Newsletter Strip */}
        <div className="consultancy-glass-card p-4 mb-5" style={{ borderRadius: "18px" }}>
          <div className="row align-items-center">
            <div className="col-lg-6 mb-3 mb-lg-0">
              <h4 className="consultancy-gold-title font-weight-bold mb-1">Stay Ahead in the Overseas Education Industry</h4>
              <p className="text-muted small mb-0">Get exclusive SaaS product updates, university partnership reports, and counsellor productivity guides.</p>
            </div>
            <div className="col-lg-6">
              {subscribed ? (
                <div className="alert alert-success py-2 font-weight-bold mb-0 text-center">
                  <i className="fas fa-check-circle mr-2"></i> Thank you! You're subscribed to EdOps Industry Updates.
                </div>
              ) : (
                <form onSubmit={handleSubscribe} className="d-flex gap-2">
                  <input
                    type="email"
                    className="form-control consultancy-form-control"
                    placeholder="Enter your work email address..."
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                  />
                  <button type="submit" className="consultancy-btn-gold px-4 whitespace-nowrap">
                    Subscribe
                  </button>
                </form>
              )}
            </div>
          </div>
        </div>

        {/* Footer Navigation Columns */}
        <div className="row g-4 mb-5">
          {/* Brand Col */}
          <div className="col-lg-3 col-md-6">
            <div className="d-flex align-items-center mb-3">
              <span className="font-weight-bold text-white fs-5">EDOPS OS</span>
            </div>
            <p className="small text-muted mb-3" style={{ lineHeight: "1.7" }}>
              The Operating System for Overseas Education Consultancies. Streamlining lead pipeline, counsellor tasks, university applications, commission tracking, and branch performance.
            </p>
            <div className="d-flex gap-2">
              <a href="#linkedin" className="btn btn-sm btn-outline-secondary rounded-circle"><i className="fab fa-linkedin-in"></i></a>
              <a href="#twitter" className="btn btn-sm btn-outline-secondary rounded-circle"><i className="fab fa-twitter"></i></a>
              <a href="#youtube" className="btn btn-sm btn-outline-secondary rounded-circle"><i className="fab fa-youtube"></i></a>
            </div>
          </div>

          {/* Platform */}
          <div className="col-lg-2 col-md-6">
            <h6 className="consultancy-gold-title font-weight-bold text-uppercase mb-3" style={{ letterSpacing: "1px" }}>Platform</h6>
            <ul className="list-unstyled d-flex flex-column gap-2 small">
              <li><Link to="/" className="text-muted text-decoration-none hover-gold">Counselling CRM</Link></li>
              <li><Link to="/consultancy/courses" className="text-muted text-decoration-none hover-gold">Lead Pipeline</Link></li>
              <li><Link to="/consultancy/services" className="text-muted text-decoration-none hover-gold">Application Tracker</Link></li>
              <li><Link to="/consultancy/universities" className="text-muted text-decoration-none hover-gold">University Catalog</Link></li>
              <li><Link to="/consultancy/scholarships" className="text-muted text-decoration-none hover-gold">Commission Engine</Link></li>
              <li><Link to="/consultancy/services" className="text-muted text-decoration-none hover-gold">Document Vault</Link></li>
            </ul>
          </div>

          {/* Solutions */}
          <div className="col-lg-2 col-md-6">
            <h6 className="consultancy-gold-title font-weight-bold text-uppercase mb-3" style={{ letterSpacing: "1px" }}>Solutions</h6>
            <ul className="list-unstyled d-flex flex-column gap-2 small">
              <li><Link to="/consultancy/about" className="text-muted text-decoration-none hover-gold">Small Consultancies</Link></li>
              <li><Link to="/consultancy/about" className="text-muted text-decoration-none hover-gold">Growing Agencies</Link></li>
              <li><Link to="/consultancy/about" className="text-muted text-decoration-none hover-gold">Multi-Branch Networks</Link></li>
              <li><Link to="/consultancy/about" className="text-muted text-decoration-none hover-gold">Education Agent Hubs</Link></li>
              <li><Link to="/consultancy/services" className="text-muted text-decoration-none hover-gold">Franchise Controls</Link></li>
            </ul>
          </div>

          {/* Company & Resources */}
          <div className="col-lg-2 col-md-6">
            <h6 className="consultancy-gold-title font-weight-bold text-uppercase mb-3" style={{ letterSpacing: "1px" }}>Company</h6>
            <ul className="list-unstyled d-flex flex-column gap-2 small">
              <li><Link to="/consultancy/about" className="text-muted text-decoration-none hover-gold">About Us</Link></li>
              <li><Link to="/consultancy/success-stories" className="text-muted text-decoration-none hover-gold">Case Studies</Link></li>
              <li><Link to="/consultancy/blog" className="text-muted text-decoration-none hover-gold">Industry Blog</Link></li>
              <li><Link to="/consultancy/contact" className="text-muted text-decoration-none hover-gold">Contact Sales</Link></li>
              <li><Link to="/consultancy/book-consultation" className="text-muted text-decoration-none hover-gold">Book a Demo</Link></li>
            </ul>
          </div>

          {/* Contact Info */}
          <div className="col-lg-3 col-md-6">
            <h6 className="consultancy-gold-title font-weight-bold text-uppercase mb-3" style={{ letterSpacing: "1px" }}>Enterprise Sales</h6>
            <ul className="list-unstyled d-flex flex-column gap-2 small">
              <li><i className="fas fa-map-marker-alt text-warning mr-2"></i> Level 5, EdOps Tech Hub, Jubilee Hills, Hyderabad - 500033</li>
              <li><i className="fas fa-phone-alt text-warning mr-2"></i> +91 1800-425-9988 / +91 98765 43210</li>
              <li><i className="fas fa-envelope text-warning mr-2"></i> sales@edopsglobal.com</li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-4 d-flex flex-column flex-md-row justify-content-between align-items-center small text-muted" style={{ borderTop: "1px solid rgba(255, 255, 255, 0.08)" }}>
          <div>&copy; {new Date().getFullYear()} EdOps OS Inc. All rights reserved. The Operating System for Overseas Education Consultancies.</div>
          <div className="d-flex gap-3 mt-2 mt-md-0">
            <a href="#privacy" className="text-muted text-decoration-none">Privacy Policy</a>
            <span>&bull;</span>
            <a href="#terms" className="text-muted text-decoration-none">Terms of Service</a>
            <span>&bull;</span>
            <a href="#security" className="text-muted text-decoration-none">Enterprise Security</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default ConsultancyFooter;
